import services from '../services'
import * as types from './mutation-types'

export const GetVideos = ({ commit }, params) => (
  services.listVideos(params).then(res => {
    commit(types.SET_VIDEOS, res.data)
    return res.data
  })
)

export const GetVideo = async ({ commit }, id) => {
  await services.getVideo(id).then(res => {
    commit(types.SET_VIDEO, res.data.data)
  })
}

export const SaveVideo = async ({ commit }, obj) => {
  return services.saveVideo(obj).then(res => {
    commit(types.SET_VIDEO, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const orderList = async ({ commit }, obj) => {
  await services.orderList(obj).then(res => {
    commit(types.SET_VIDEOS, res.data.data)
    return res.data
  })
}

export const deleteVideo = async ({ commit }, obj) => {
  await services.deleteVideo(obj).then(res => {
    return res
  })
}
